export default __webpack_public_path__ + "static/Poppins-Regular-a6824ee4d498fe7367c717e6953bd87c.woff2";